/**
 * Ops are immer draft mutators `(draft, args) => result`. Wrap them so the recipe itself returns nothing:
 *   produceWithPatches(doc, d => { res = op(d, args); })
 * An op that can refuse (R12, or a missing target) returns an OpResult and leaves the draft untouched when it refuses.
 */

/** Outcome of an op that can refuse. `reason` is plain English for the UI. */
export type OpResult<T = true> = { ok: true; value: T } | { ok: false; reason: string };

/** A successful OpResult. */
export function ok<T>(value: T): OpResult<T> {
  return { ok: true, value };
}

/** A refused OpResult. */
export function refuse<T = never>(reason: string): OpResult<T> {
  return { ok: false, reason };
}
